module.exports = __webpack_public_path__ + "static/site-1784739815621/img/bg-clouds-mobile.91a460c4.png";